import Modal from "./Modal";
import React from "react";
import ContentApi from "../../api/ContentApi";


type ModalAjaxProps = {
    source: string,
    onClose: () => void,
    isOpen?: boolean,
}
const ModalAjax = ({source, onClose, isOpen}:ModalAjaxProps) =>{

    const [title, setTitle] = React.useState('');
    const [text, setText] = React.useState('');
    const [isLoad, setIsLoad] = React.useState(false);

    React.useEffect(() => {
        if (isOpen && !isLoad) {
            ContentApi.getBy({filter: {slug: source}}).then((data) => {
                if (data.content.items) {
                    data.content.items.forEach(function (item: any) {
                        setTitle(item.title);
                        setText(item.text);
                        setIsLoad(true);
                    })
                }
            });
        }
    }, [isOpen])

    return <Modal title={title} text={text} isOpen={isOpen} onClose={onClose}/>
}

export default ModalAjax;
